import React, { useState, useEffect } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Slide from '@mui/material/Slide';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

const StyledSnackbar = styled(React.forwardRef((props, ref) => (
  <Snackbar ref={ref} {...props} />
)))(({ theme }) => ({
  '& .snackbarStyleViaContentProps': {
    backgroundColor: '#206AF5',
    fontWeight: 'bold'
  }
}));

function TransitionDown(props) {
  return <Slide {...props} direction="down" />;
}

function Notification({ state, position, duration, message, resetGlobalState }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (state) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [state]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
    resetGlobalState && resetGlobalState();
  };

  return (
    <>
      <StyledSnackbar
        anchorOrigin={position}
        autoHideDuration={duration}
        ContentProps={{
          'aria-describedby': 'message-id',
          className: 'snackbarStyleViaContentProps'
        }}
        message={message}
        open={open}
        style={{ top: '100px' }}
        TransitionComponent={TransitionDown}
        onClose={handleClose}
      />
    </>
  );
}

Notification.propTypes = {
  state: PropTypes.bool,
  position: PropTypes.object,
  duration: PropTypes.number,
  message: PropTypes.string,
  resetGlobalState: PropTypes.func
};

export default Notification;
